import {
  Receipt,
  Users,
  Warehouse,
  BellRing,
  Wallet,
  BarChart3,
  CheckCircle2,
} from 'lucide-react'

export default function FeatureGridSection() {
  const features = [
    {
      icon: Receipt,
      title: 'Factures et paiements mieux suivis',
      desc: 'Créez vos factures, enregistrez les paiements et visualisez rapidement ce qui reste à encaisser.',
    },
    {
      icon: Users,
      title: 'Clients mieux organisés',
      desc: 'Gardez des fiches clients propres avec leurs coordonnées, leur balance et leur historique.',
    },
    {
      icon: Warehouse,
      title: 'Stock plus clair',
      desc: 'Suivez vos produits, vos dépôts, vos conteneurs et vos mouvements sans vous perdre.',
    },
    {
      icon: BellRing,
      title: 'Relances plus simples',
      desc: 'Rappelez les clients qui ont des dettes en retard sans tout gérer manuellement.',
    },
    {
      icon: Wallet,
      title: 'Meilleure maîtrise de l’argent',
      desc: 'Suivez les encaissements, les dépenses et gardez une vue plus nette sur votre activité.',
    },
    {
      icon: BarChart3,
      title: 'Pilotage plus facile',
      desc: 'Consultez des indicateurs utiles pour comprendre vos ventes, vos créances et vos charges.',
    },
  ]

  return (
    <section className='border-t bg-muted/20'>
      <div className='mx-auto max-w-7xl px-4 py-16'>
        <div className='mx-auto max-w-3xl text-center'>
          <h2 className='text-3xl font-bold tracking-tight'>
            Ce que MOGESAPP vous apporte au quotidien
          </h2>
          <p className='mt-3 text-muted-foreground'>
            Avant même de parcourir toute la documentation, voici les bénéfices
            concrets que vous obtenez en utilisant l’application.
          </p>
        </div>

        <div className='mt-10 grid gap-6 sm:grid-cols-2 xl:grid-cols-3'>
          {features.map((feature) => {
            const Icon = feature.icon

            return (
              <div
                key={feature.title}
                className='rounded-2xl border bg-background p-6 shadow-sm'
              >
                <div className='flex items-center gap-3'>
                  <div className='rounded-xl bg-primary/10 p-2.5'>
                    <Icon className='h-5 w-5 text-primary' />
                  </div>
                  <h3 className='font-semibold'>{feature.title}</h3>
                </div>

                <p className='mt-4 text-sm leading-6 text-muted-foreground'>
                  {feature.desc}
                </p>
              </div>
            )
          })}
        </div>

        <div className='mt-10 rounded-2xl border bg-background p-6'>
          <div className='flex items-start gap-3'>
            <CheckCircle2 className='mt-0.5 h-5 w-5 text-primary shrink-0' />
            <p className='text-sm text-muted-foreground'>
              Cette documentation est là pour vous montrer non seulement comment
              utiliser MOGESAPP, mais surtout comment en tirer une vraie valeur
              dans votre gestion quotidienne.
            </p>
          </div>
        </div>
      </div>
    </section>
  )
}
